module.exports = __webpack_public_path__ + "static/laptopWorking-8fdb52ae2517f5507b546c2b33a506d9.png";